var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
import { DURATIONS, FOCUSES, MESH_COLORS, MESH_INDICES, MESH_PICKING_USER_IDS, MESH_VERTICES, POSITIONS, } from "./utils/standardPrimitiveData";
import { Cartographic, Ellipsoid } from "../../private/math";
import { FaceCullingMode } from "../../api";
import { AnimationTrack } from "../framework/AnimationTrack";
import { EventAnimator } from "../framework/EventAnimator";
import { Vector3 } from "three";
export function primitiveMesh5(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Primitive Mesh 5" +
                "</h1>" +
                "<p>" +
                "The camera will be looking at a primitive mesh object. It should render normally with a periodically changing " +
                "material. It will also be clipped by a single clipping plane. Back/front face culling will be disabled." +
                "</p>";
        let group;
        let object;
        yield sceneFlyover(defaultRendererConfig(container), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const positionCartographic = new Cartographic(2.633667667706, -0.601510430485, 6);
            const position = Ellipsoid.WGS_84.cartesianForCartographic(positionCartographic);
            const normal = new Vector3(0, 1, 1).normalize();
            group = renderer.createClippingGroup();
            group.planes.push({
                position,
                normal,
            });
            group.setEnabled(true);
            const mesh = renderer.createIndexedTriangleMesh();
            mesh.vertices = MESH_VERTICES;
            mesh.color = MESH_COLORS;
            mesh.pickingUserId = MESH_PICKING_USER_IDS;
            mesh.indices = MESH_INDICES;
            mesh.resolve();
            object = renderer.getObjectFactory().createRawMeshObject({
                position: {
                    cartographic: {
                        longitude: 2.633667667706,
                        latitude: -0.601510430485,
                        height: 5,
                    },
                },
                mesh,
                material: {
                    type: "basicOpaque",
                    color: { r: 1, g: 1, b: 1 },
                    vertexColors: true,
                },
            });
            group.addObject(object);
            renderer.getWorld().addObject(object);
            group.resolvePlanes();
        }), () => {
            const eTrack = new AnimationTrack();
            for (let i = 0; i < 7; i += 1) {
                eTrack.add(1, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, () => {
                    object.applyMaterial({
                        type: "basicOpaque",
                        color: {
                            r: 0,
                            g: 1,
                            b: 0,
                        },
                        faceCulling: FaceCullingMode.None,
                    });
                }));
                eTrack.add(1, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, () => {
                    object.applyMaterial({
                        type: "basicAlpha",
                        color: {
                            r: 0,
                            g: 1,
                            b: 1,
                        },
                        alpha: 0.6,
                        vertexColors: true,
                        faceCulling: FaceCullingMode.None,
                    });
                }));
                eTrack.add(1, (beginTime, endTime) => EventAnimator.at(beginTime, endTime, () => {
                    object.applyMaterial({
                        type: "basicOpaque",
                        color: {
                            r: 1,
                            g: 0.5,
                            b: 0.2,
                        },
                        vertexColors: true,
                        faceCulling: FaceCullingMode.None,
                    });
                }));
            }
            return [eTrack];
        });
    });
}
